import { createFeatureSelector, createReducer, on } from '@ngrx/store';

import { LegalDocument } from '../../model/LegalDocument';
import { LegalDocumentsActions } from '../actions/legalDocument';

export interface LegalDocumentsState {
    approvalDate: number;
    documents: Record<string, LegalDocument>;
    documentsToSign: LegalDocument[];
}

export const LEGAL_DOCUMENTS_INITIAL_STATE: LegalDocumentsState = {
    approvalDate: null,
    documents: {},
    documentsToSign: [],
};

export default createReducer(
    LEGAL_DOCUMENTS_INITIAL_STATE,

    on(
        LegalDocumentsActions.approvalLoaded,
        (state, { approvalDate, approvedDocuments }): LegalDocumentsState => ({
            ...state,
            approvalDate,
            documents: Object.fromEntries(approvedDocuments.map((doc) => [doc.documentType, doc])),
        }),
    ),

    on(
        LegalDocumentsActions.signingRequested,
        (state, { documents }): LegalDocumentsState => ({ ...state, documentsToSign: documents }),
    ),

    on(LegalDocumentsActions.documentsApproved, (state): LegalDocumentsState => ({ ...state, documentsToSign: [] })),
);

export const getLegalDocumentsState = createFeatureSelector<LegalDocumentsState>('legal-documents');
